<template>
  <div>
    <CarteDisplay v-for="(locationCarte, ci) in locationCartes" :key="ci" :carte="locationCarte.carte" :display="locationCarte.display" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CarteDisplay from '@/components/CarteDisplay'

export default {
    name: 'LocationCartesDisplay',
    components: { CarteDisplay },
    asyncComputed: {
        ...mapState(['location']),
        locationCartes() {
            if (this.location) return this.location.cartes
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/style/settings.scss";

.carte {
  text-align: left;
  .title {
    text-transform: uppercase;
    font-size: 2.5em;
    font-weight: bold;
  }
}
</style>
